<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="520">
    <v-card class="rounded-xl">
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left color="amber darken-2">mdi-note-text-outline</v-icon>
        Nota de {{ nodo && nodo.name }}
      </v-card-title>
      <v-card-subtitle class="pt-1">Solo la ve el personal de Ramos.</v-card-subtitle>
      <v-card-text>
        <v-textarea
          v-model="texto"
          label="Nota"
          placeholder="Por ejemplo: revisar el diferencial en la próxima visita"
          outlined
          auto-grow
          rows="4"
          counter="2000"
          :rules="[(v) => !v || v.length <= 2000 || 'Máximo 2000 caracteres']"
          autofocus
        />
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="nodo && nodo.nota" text color="error" class="text-none" :disabled="guardando" @click="$emit('guardar', { nodo, nota: null })">
          <v-icon left small>mdi-delete-outline</v-icon> Borrar nota
        </v-btn>
        <v-spacer />
        <v-btn text @click="$emit('update:dialog', false)">Cancelar</v-btn>
        <v-btn color="primary" depressed :loading="guardando" :disabled="!cambiado || texto.length > 2000" @click="$emit('guardar', { nodo, nota: texto.trim() || null })">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Nota interna de un armario (la escriben los técnicos de Ramos)
export default {
  name: "DialogNotaArmario",
  props: {
    dialog: { type: Boolean, default: false },
    nodo: { type: Object, default: null },
    guardando: { type: Boolean, default: false },
  },
  data() {
    return { texto: "" };
  },
  computed: {
    cambiado() {
      return this.texto.trim() !== ((this.nodo && this.nodo.nota) || "").trim();
    },
  },
  watch: {
    dialog: {
      immediate: true,
      handler(abierto) {
        if (abierto) this.texto = (this.nodo && this.nodo.nota) || "";
      },
    },
  },
};
</script>
